import React, { useRef } from "react";

import PageBanner from "../../layouts/PageBanner";

import president from "../../assets/images/TheSigningOfficers/sats_president.jpg";
import ApiServer from "../../helpers/Api_help";

const Announcement = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="PRESIDENT’S MESSAGE" />
        <section className="content-inner-2 section-wrapper5">
          <div className="container text-dark">
            <div className="row align-items-center">
              <div
                className="col-lg-12 d-flex flex-wrap justify-content-between align-items-center
              "
              >
                {/* <div className="section-head col-lg-6 col-md-6 col-sm-12"> */}
                <h3>
                  வணக்கம்!
                  <br />
                </h3>

                <p className="m-t20 text-justify">
                  2026–2027 ஆம் ஆண்டிற்கான சான் அண்டோனியோ தமிழ்ச் சங்கத்தின்
                  தலைவராகப் பொறுப்பேற்பது எனக்கு மிகுந்த பெருமையையும் பணிவையும்
                  அளிக்கிறது. அனைவர் பங்களிப்பாலும் வளர்ந்து, ஒற்றுமை,
                  அனைவரையும் அரவணைக்கும் பண்பு மற்றும் தமிழர் பண்பாட்டு பெருமையை
                  அடித்தளமாகக் கொண்டு இயங்கி வரும் இச்சங்கத்தின் தலைமைப்
                  பொறுப்பை ஏற்கும் வாய்ப்பு கிடைத்ததற்கு நான் பெருமகிழ்ச்சி
                  அடைகிறேன்.
                  <br /> <br />
                  <div className="card shadow-sm border-0 mb-4">
                    <div className="row g-0 align-items-center">
                      <div className="col-lg-5 col-md-5 col-sm-12 text-center">
                        <img
                          src={`${ApiServer}assets/committee/sats_president.jpg`}
                          alt="president"
                          className="img-fluid rounded-start"
                          style={{
                            width: "100%",
                            maxHeight: "400px",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      <div className="col-lg-7 col-md-7 col-sm-12">
                        <div className="card-body">
                          <p className="card-text text-justify mb-0">
                            என்மீதும், எங்கள் புதிய அணியின்மீதும் நம்பிக்கை
                            வைத்து ஆதரவளித்த உறுப்பினர்கள், தன்னார்வலர்கள்,
                            முன்னாள் நிர்வாகிகள் மற்றும் நலன் விரும்பிகள்
                            அனைவருக்கும் என் மனமார்ந்த நன்றியைத் தெரிவித்துக்
                            கொள்கிறேன்.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br /> <br />
                  என்னைப் பொறுத்தவரை, “நம்ம SATS” என்பது ஒரு சங்கம் மட்டுமல்ல;
                  அது நம் தாய்நாட்டிலிருந்து தொலைவில் வாழும் நமக்கான இன்னொரு
                  இல்லம். தமிழ் மொழி, பண்பாடு, பாரம்பரியம் மற்றும் சமூகப்
                  பண்புகளை நேசிக்கும் இதயங்களை ஒன்றிணைக்கும் குடும்பம். இங்கு
                  நட்புகள் உறவுகளாக மலர்கின்றன; நம் குழந்தைகள் தங்களது வேர்களை
                  அறிந்து பெருமிதம் கொள்கின்றனர்; தலைமுறைகள் ஒன்றிணைந்து தமிழர்
                  மரபின் அழகையும் பெருமையையும் கொண்டாடுகின்றன.
                  <br /> <br />
                  “கருமம் செயஒருவன் கைதூவேன் என்னும் <br />
                  பெருமையின் பீடுடையது இல்” - திருக்குறள்
                  <br />
                  <br />
                  ஒரு செயலை ஏற்று மேற்கொண்டவர், அதனை எந்தச் சிரமமும் வந்தாலும்
                  மனம் தளராது நிறைவேற்றுவேன் என்ற உறுதியை விட உயர்ந்த பெருமை
                  வேறில்லை என்பதை இந்தக் குறள் நமக்கு உணர்த்துகிறது. அதேபோல்,
                  ஒருமித்த நோக்கத்துடனும், பொறுப்புணர்வுடனும், ஒற்றுமையுடனும்
                  செயல்படும் போது எந்த சமூகமும் உயர்வடைந்து நிலைத்திருக்கும்.
                  <br /> <br />
                  இந்த புதிய பயணத்தைத் தொடங்கும் இந்நேரத்தில், “நம்ம SATS”
                  இன்னும் வலிமையான, நெருக்கமான மற்றும் துடிப்பான சமூகமாக வளர
                  வேண்டும் என்பதே எங்களின் தெளிவான இலக்காகும். அர்த்தமுள்ள
                  பண்பாட்டு நிகழ்வுகளை உருவாக்குதல், தமிழ்க் கல்வியை மேலும்
                  வலுப்படுத்துதல், இளைஞர்களின் தலைமைத்துவத்தை ஊக்குவித்தல், சமூக
                  சேவைகளை விரிவுபடுத்துதல் மற்றும் ஒவ்வொரு உறுப்பினரும்
                  மதிக்கப்படுகிறோம் என்ற உணர்வோடு தங்களின் பங்களிப்பை
                  வழங்கக்கூடிய சூழலை உருவாக்குதல் ஆகியவை எங்கள் முக்கிய
                  நோக்கங்களாகும்.
                  <br /> <br />
                  ஒரு தலைவரால் மட்டும் எந்த அமைப்பும் வெற்றி பெற முடியாது. சான்
                  அண்டோனியோ தமிழ்ச் சங்கத்தின் உண்மையான பலம் அதன் உறுப்பினர்கள்,
                  தன்னார்வலர்கள், குடும்பங்கள், நன்கொடையாளர்கள், முன்னாள்
                  நிர்வாகிகள் மற்றும் இந்தச் சமூகத்தின் வளர்ச்சிக்காக தங்கள்
                  நேரத்தையும் உழைப்பையும் அன்போடு வழங்கும் ஒவ்வொருவருமே ஆவர்.
                  <br /> <br />
                  ஒரே நோக்கத்துடனும், ஒரே மனதுடனும் நாம் அனைவரும் இணைந்து, இனிய
                  நினைவுகளை உருவாக்கி, நம் பாரம்பரியத்தைப் பாதுகாத்து, வருங்கால
                  தலைமுறைகளுக்கான அர்த்தமுள்ள பாரம்பரியச் சுவடுகளை
                  உருவாக்குவோம்.
                  <br />
                  <br />
                  ஒன்றாக வளர்வோம்… ஒன்றாக கொண்டாடுவோம்… ஒன்றாக வழிநடத்துவோம்…
                  <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    முனைவர். யுவராஜ் முனியன்
                  </span>
                  <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    தலைவர் (2026 - 2027)
                  </span>
                  <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    சான் அண்டோனியோ தமிழ்ச் சங்கம்
                  </span>
                </p>

                {/* </div> */}

                <p className="m-t20 text-justify">
                  I am deeply honoured and privileged to serve as{" "}
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    President of San Antonio Tamil Sangam (SATS){" "}
                  </span>
                  for the 2026-2027 term, an organization built upon the values
                  of inclusiveness, unity, and cultural pride. I sincerely thank
                  every member, volunteer, past leader, and well-wisher who has
                  placed their trust in me and in our team.
                  <br /> <br />
                  To me,{" "}
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    “Namma SATS”
                  </span>{" "}
                  is not simply an organization, it is a home away from home, a
                  family woven together by our shared love for Tamil language,
                  culture, traditions, and community values. It is a place where
                  friendships become family, where our children discover their
                  roots, and where generations unite to celebrate the pride and
                  beauty of Tamil heritage.
                  <br /> <br />
                  “கருமம் செயஒருவன் கைதூவேன் என்னும் <br />
                  பெருமையின் பீடுடையது இல்” - Thirukkural
                  <br />
                  <br />
                  The essence reminds us that relationships and unity are
                  stronger than momentary differences. When people come together
                  with understanding and shared purpose, communities flourish
                  and endure.
                  <br /> <br />
                  As we begin this new chapter, our vision is clear to make
                  “Namma SATS” a stronger, more connected, and more vibrant
                  community. We aspire to create meaningful cultural
                  celebrations, strengthen Tamil education, encourage youth
                  leadership, expand community outreach, and build opportunities
                  where every member feels valued and inspired to contribute.
                  <br /> <br />
                  No President succeeds alone. The true strength of SATS has
                  always been its people, our volunteers, families, sponsors,
                  past leaders, and every member who gives their time and heart
                  to this community. Together, with one vision and one purpose,
                  let us continue building memories, preserving traditions, and
                  creating a legacy for future generations.
                  <br /> <br />
                  Let us grow together. Let us celebrate together. Let us lead
                  together.
                  <br />
                  <br />
                  With warm regards, <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    Dr. Yuvaraj Munian
                  </span>
                  <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    President
                  </span>
                  <br />
                  <span style={{ fontWeight: 600, color: "#000" }}>
                    San Antonio Tamil Sangam (2026–2027)
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Announcement;
